import { SvgIcon } from '@mui/material';
import React from 'react';

export default function LineChartIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 44 44" style={{ width: `22px`, height: `22px`, color: `#1D1D1B`, ...props.style }}>
      <path d="M39.31,5.08c-2.27,0-4.11,1.84-4.11,4.11,0,1.06,.41,2.02,1.07,2.75l-6.45,12.78c-.17-.02-.34-.05-.51-.05-.75,0-1.44,.21-2.04,.56l-6.37-5.61c.19-.47,.3-.98,.3-1.52,0-2.27-1.84-4.11-4.11-4.11s-4.11,1.84-4.11,4.11c0,.79,.23,1.51,.62,2.14l-7.83,10.64c-.35-.09-.7-.16-1.08-.16-2.27,0-4.11,1.84-4.11,4.11s1.84,4.11,4.11,4.11,4.11-1.84,4.11-4.11c0-.82-.25-1.57-.66-2.21l7.79-10.59c.37,.11,.75,.19,1.16,.19,.65,0,1.26-.17,1.81-.43l6.52,5.75c-.13,.4-.22,.82-.22,1.26,0,2.27,1.84,4.11,4.11,4.11s4.11-1.84,4.11-4.11c0-1.02-.39-1.95-1.01-2.67l6.49-12.85c.14,.01,.27,.04,.41,.04,2.27,0,4.11-1.84,4.11-4.11s-1.84-4.11-4.11-4.11Z" />
    </SvgIcon>
  );
}
